import { formatDateTimeLocal } from "@/shared/lib/date-time-performance";
import type { EventDateChangeDTO } from "../../domain/contracts";

type EventPostponeHistoryProps = {
  items: EventDateChangeDTO[];
  isLoading?: boolean;
};

function formatChangeDate(value: Date | string | null | undefined) {
  if (!value) return "ຍັງບໍ່ກຳນົດ";
  return formatDateTimeLocal(new Date(value));
}

export function EventPostponeHistory({
  items,
  isLoading,
}: EventPostponeHistoryProps) {
  if (isLoading) {
    return (
      <p className="text-muted-foreground text-sm">ກຳລັງໂຫຼດປະຫວັດການເລື່ອນ...</p>
    );
  }

  if (items.length === 0) return null;

  return (
    <div className="rounded-xl border bg-card px-4 py-3">
      <p className="mb-2 font-semibold text-sm">ປະຫວັດການເລື່ອນວັນ</p>
      <ul className="space-y-2">
        {items.map((item) => (
          <li
            key={item.id}
            className="border-border/60 border-l-2 pl-3 text-sm"
          >
            <p className="font-medium">
              {formatChangeDate(item.previousEventDate)}
              {" → "}
              {item.indefinite || !item.newEventDate
                ? "ຍັງບໍ່ກຳນົດ"
                : formatChangeDate(item.newEventDate)}
            </p>
            <p className="text-muted-foreground text-xs">{item.reason}</p>
            <p className="mt-0.5 text-muted-foreground text-xs">
              {formatDateTimeLocal(new Date(item.createdAt))}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
}
